import React, { useEffect, useState } from 'react';
import { motion, useScroll, useMotionValueEvent } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useMotionValueEvent(scrollY, 'change', latest => {
    setIsScrolled(latest > 50);
  });
  const navLinks = [{
    name: 'Property',
    href: '#property'
  }, {
    name: 'Location',
    href: '#location'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: [0.16, 1, 0.3, 1]
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-brand-black/90 backdrop-blur-md py-4 border-b border-white/5' : 'bg-transparent py-6'}`} data-id="element-90">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-91">
        {/* Logo */}
        <a href="#" className="flex items-center" data-id="element-92">
          <img src="https://cdn.magicpatterns.com/uploads/njzqrqDh79LXJM1gwhkevk/morley.svg" alt="Morley" className="h-8" data-id="element-93" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-10" data-id="element-94">
          <div className="flex space-x-8" data-id="element-95">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-brand-cream/80 hover:text-brand-gold text-sm tracking-widest uppercase transition-colors duration-300" data-id="element-96">
                {link.name}
              </a>)}
          </div>
          <a href="#enquire" className="px-6 py-2.5 bg-brand-gold text-brand-black text-sm font-medium tracking-widest uppercase hover:bg-white transition-colors duration-300" data-id="element-97">
            Enquire
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden text-brand-cream" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-98">
          {mobileMenuOpen ? <X size={24} data-id="element-99" /> : <Menu size={24} data-id="element-100" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} className="md:hidden bg-brand-black border-b border-white/10 px-6 py-8 flex flex-col space-y-6" data-id="element-101">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-brand-cream text-lg font-heading tracking-wider" data-id="element-102">
              {link.name}
            </a>)}
          <a href="#enquire" onClick={() => setMobileMenuOpen(false)} className="inline-block text-center px-6 py-3 bg-brand-gold text-brand-black text-sm font-medium tracking-widest uppercase" data-id="element-103">
            Enquire
          </a>
        </motion.div>}
    </motion.nav>;
}